import { AuthorCard } from 'components/Author/AuthorCard';
import { Box } from 'components/Box';
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { CmsRecommendedJobsBlock } from 'modules/cms/blocks/RecommendedJobs/CmsRecommendedJobsBlock';
import { CmsTagList } from 'modules/cms/components/TagList';
import { getIsContentFullWidthLayout } from 'modules/cms/helpers';
import { useCmsApiPageHomePageMeta } from 'modules/cms/hooks';

type Props = {
  content: CmsApiPage;
};

export function CmsBelowBlocks({ content }: Props) {
  const { homePageUrl } = useCmsApiPageHomePageMeta({
    cmsApiPage: content,
  });
  const fullWidthLayout = getIsContentFullWidthLayout({ content });
  return (
    <>
      {content.tags && content.tags.length > 0 && (
        <Box mb={32}>
          <CmsTagList
            homePageUrl={
              content.subsite.homePage && content.subsite.homePage.url
            }
            tags={content.tags}
          />
        </Box>
      )}

      {content.author && (
        <AuthorCard
          author={content.author}
          homePageUrl={homePageUrl}
          postedDate={content.postedDate}
          showDate={content.showDate}
          fullWidthLayout={fullWidthLayout}
        />
      )}

      {content.hasRecommendedJobs && (
        <CmsRecommendedJobsBlock
          data={{
            headline: content.recommendedJobsHeadline,
            layout: 'REGULAR',
            jobFunction: undefined,
          }}
        />
      )}
    </>
  );
}
